import { forwardRef, memo } from "react";
import classNames from "classnames";
import { useIsMobileView } from "../../../../utils";
import { StepBase } from "../../StepBase";
import { ProgressIconsWithText } from "../ProgressIconsWithText";
import { ProgressStepItem, ProgressStepProps } from "../types";
import { getIndicatorState } from "../utils";

import styles from "./style.module.scss";

export type ProgressStepContainerProps = ProgressStepProps;

export const ProgressIconsCentered = memo(
  forwardRef<HTMLDivElement, ProgressStepContainerProps>(
    (
      {
        steps,
        className,
        currentStep = 0,
        size = "sm",
        ...props
      },
      ref,
    ) => {
      const isMobileView = useIsMobileView();

      if (isMobileView) {
        return (
          <ProgressIconsWithText
            steps={steps}
            size={size}
            currentStep={currentStep}
            {...props}
          />
        );
      }

      return (
        <div
          className={classNames(styles.root, className)}
          {...props}
          ref={ref}
        >
          {
            steps?.map((item: ProgressStepItem, index: number) => {
              const isFirst = index === 0;
              const isLast = index === steps.length - 1;
              return (
                <StepBase
                  {...item}
                  id={`${item?.id}`}
                  key={item.id}
                  size={size}
                  type={item.icon ? "featuredIconTop" : "iconTop"}
                  status={getIndicatorState(index, currentStep)}
                  featuredIconWrapperClassName={classNames(styles.iconContainer, item.featuredIconWrapperClassName)}
                  iconWrapperClassName={classNames(
                    styles.connector,
                    item.iconWrapperClassName,
                    {
                      [styles.firstStep]: isFirst,
                      [styles.lastStep]: isLast,
                      [styles.colorConnector]: item.icon,
                      [styles.completeBeforeConnector]: index < currentStep + 1,
                      [styles.completeAfterConnector]: index < currentStep,
                    },
                  )}
                />
              );
            })
          }
        </div>
      );
    },
  ),
);
